export default __webpack_public_path__ + "static/Brandon-Light-300-afd3777813583ac57dddd0381924502b.woff2";